'use strict'

import { codeData } from '../utils/codeData';

const individual = {
    path: 'individuals',
    name: 'individual-list',
    meta: {
        title: '个体信息-签约管理-综合服务平台',
        name: '个体信息',
        tagsTitle: '个体信息',
        code: ''
    },
    redirect: {
        name: 'individual-list-info'
    },
    component: () => import('@/components/RouterView'),
    children: [
        {
            path: '',
            name: 'individual-list-info',
            meta: {
                title: '个体信息-签约管理-综合服务平台',
                name: '',
                tagsTitle: '个体信息',
                code: ''
            },
            component: () => import('@/pages/individual/List'),
        },
        {
            path: 'individual/:id',
            name: 'individual-detail',
            meta: {
                title: '个体详情-签约管理-综合服务平台',
                name: '个体详情',
                tagsTitle: '个体详情',
                code: ''
            },
            component: () => import('@/pages/individual/IndividualDetail'),
        },
    ]
};

export default individual;